<div class="header-bar">
    <div class="header-left">
        <div class="header-text">{{ providerName }} Preview</div>
    </div>
    <div class="header-center"></div>
    <div class="header-right">
        <mat-button-toggle-group class="view-mode-toggle" [(ngModel)]="viewMode" appearance="standard">
            <mat-button-toggle value="mobile">Mobile</mat-button-toggle>
            <mat-button-toggle value="desktop">Desktop</mat-button-toggle>
        </mat-button-toggle-group>
        <button
            mat-stroked-button
            color="primary"
            [routerLink]="docsUrl"
        >
            Docs
        </button>
    </div>
</div>

<div class="preview-body" [ngClass]="viewMode">
    <app-tripist-embed
        *ngIf="integration?.external_id"
        [integrationExternalId]="integration.external_id"
        [integrationId]="integration.id"
        [autoIdentify]="true"
        [isTestThread]="true"
        [viewMode]="viewMode"
    ></app-tripist-embed>
</div>
